/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import React from "react";
import {
  getOverrideProps,
  getOverridesFromVariants,
  mergeVariantsAndOverrides,
} from "@aws-amplify/ui-react/internal";
import { Flex, Text } from "@aws-amplify/ui-react";
export default function ListSyain(props) {
  const { overrides: overridesProp, ...rest } = props;
  const variants = [
    {
      overrides: { name: {}, answer: {}, ListSyain: {} },
      variantValues: { status: "Answer", bg: "gray" },
    },
    {
      overrides: {
        name: {},
        answer: {},
        ListSyain: { backgroundColor: "rgba(255,255,255,1)" },
      },
      variantValues: { status: "Answer", bg: "white" },
    },
    {
      overrides: {
        name: {},
        answer: { color: "rgba(255,76,79,1)", children: "\u672A\u56DE\u7B54" },
        ListSyain: {},
      },
      variantValues: { status: "NoAnswer", bg: "gray" },
    },
    {
      overrides: {
        name: {},
        answer: { color: "rgba(255,76,79,1)", children: "\u672A\u56DE\u7B54" },
        ListSyain: { backgroundColor: "rgba(255,255,255,1)" },
      },
      variantValues: { status: "NoAnswer", bg: "white" },
    },
  ];
  const overrides = mergeVariantsAndOverrides(
    getOverridesFromVariants(variants, props),
    overridesProp || {}
  );
  return (
    <Flex
      gap="52px"
      direction="row"
      width="320px"
      height="unset"
      justifyContent="flex-start"
      alignItems="center"
      position="relative"
      padding="12px 16px 12px 16px"
      backgroundColor="rgba(245,245,245,1)"
      display="flex"
      {...rest}
      {...getOverrideProps(overrides, "ListSyain")}
    >
      <Text
        fontFamily=""
        fontSize="12px"
        fontWeight=""
        color="rgba(0,0,0,1)"
        lineHeight="12px"
        textAlign="left"
        display="block"
        direction="column"
        justifyContent="unset"
        width="unset"
        height="unset"
        gap="unset"
        alignItems="unset"
        grow="1"
        shrink="1"
        basis="0"
        position="relative"
        padding="0px 0px 0px 0px"
        whiteSpace="pre-wrap"
        children="苗字苗字 名前"
        {...getOverrideProps(overrides, "name")}
      ></Text>
      <Text
        fontFamily=""
        fontSize="12px"
        fontWeight=""
        color="rgba(0,0,0,1)"
        lineHeight="12px"
        textAlign="left"
        display="block"
        direction="column"
        justifyContent="unset"
        width="unset"
        height="unset"
        gap="unset"
        alignItems="unset"
        grow="1"
        shrink="1"
        basis="0"
        position="relative"
        padding="0px 0px 0px 0px"
        whiteSpace="pre-wrap"
        children="2022/04/15 12:00"
        {...getOverrideProps(overrides, "answer")}
      ></Text>
    </Flex>
  );
}
